// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"fae97a86","722":"599a9653","728":"ac6066ca","750":"42176745"}[chunkId] + ".chunk.js";
};